import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import './cpg.scss';
import AOS from "aos";
import "aos/dist/aos.css";

export default function CPGSummary() {

  useEffect(() => {
    AOS.init({
      once: true
    });
    AOS.refresh();
  }, []);

  return (
  
    <>
      <h5>CPG Industry Summary</h5>

      <ul className="financial-listing">
        <li>CPG businesses are the most likely to report that direct mail is <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>both cost-effective and brings in a good ROI.</span></li>
        <li>CPG companies are the <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>most likely to use the Informed Visibility<sup className='summary-symbol'>&reg;</sup> feature.</span></li>
        <li>CPG businesses typically <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>measure direct mail success via customer satisfaction.</span></li>
        <li>CPG companies usually <span data-aos data-aos-once="true" className='highlighter highlighter-summary'>share responsibilities</span> for direct mail performance measurement and mailing <span data-aos className='highlighter highlighter-summary'>with an outside agency.</span></li>
      </ul>
    </>
  );
}
